export default "__VITE_ASSET__DRgTOZ5G__"